// Get the modal
var modal = document.getElementById("myModal");

// Get the button that opens the modal
var btn = document.getElementById("myBtn");


// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks the button, open the modal 
 
  
$('#myBtn').click(function () {
  modal.style.display = "block";  
  $('body').addClass("overlay-active");  
  offsetHeight = document.getElementById('div_content_popup').offsetHeight;

});

$('#myBtn1').click(function () {
  modal.style.display = "block";
  $('body').addClass("overlay-active");     
  offsetHeight = document.getElementById('div_content_popup').offsetHeight;

});



$('#Slide1598295702318-0').click(function () {
  modal.style.display = "block";
  $('body').addClass("overlay-active");   
  offsetHeight = document.getElementById('div_content_popup').offsetHeight;
  //gtag_report_conversion();

// Get window location URL params
    var regex = /[?&]([^=#]+)=([^&#]*)/g,
        url = window.location.href,
        url_params = {},
        match;
    // Loop through the parameters
    while (match = regex.exec(url)) {
        url_params[match[1]] = match[2];
    }
    
   let endpoint = "https://4557678.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1052&deploy=1&compid=4557678&h=c504088659c15c617b44";

    // Build string to be appended as parameter for shopify cart get URL
    var theURLParamsForShopify = Object.keys(url_params).map(function(k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(url_params[k])
    }).join('&');
  
  let adsURL = endpoint+"&"+theURLParamsForShopify
  
  let myIframe = document.getElementById("popupiframe");
//             let endpoint = "https://4557678.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1052&deploy=1&compid=4557678&h=c504088659c15c617b44";
//             let url_string = window.location.href;
//             let url = new URL(url_string);
//             console.log(url_string);
//             let fbclid = url.searchParams.get("fbclid");
//             console.log(fbclid);
//             let utm_source = url.searchParams.get("utm_source");
//             console.log(utm_source);
//             let adsURL = endpoint+"&fbclid="+fbclid+"&utm_source="+utm_source;
//             console.log(adsURL);
   myIframe.src = adsURL;
});

$('.ns-popup').click(function () {
  modal.style.display = "block";
  $('body').addClass("overlay-active");   
  offsetHeight = document.getElementById('div_content_popup').offsetHeight;
  //gtag_report_conversion();
});


$('#demo_popup').click(function () {
  alert("sdjsaj");
  modal.style.display = "block";
  $('body').addClass("overlay-active");   
  offsetHeight = document.getElementById('div_content_popup').offsetHeight;
  //gtag_report_conversion();
});

$('.tp-popup-active-button').click(function () {
  modal.style.display = "block";
  $('body').addClass("overlay-active");   
  offsetHeight = document.getElementById('div_content_popup').offsetHeight;
//gtag_report_conversion();
  
// Get window location URL params
    var regex = /[?&]([^=#]+)=([^&#]*)/g,
        url = window.location.href,
        url_params = {},
        match;
    // Loop through the parameters
    while (match = regex.exec(url)) {
        url_params[match[1]] = match[2];
    }
    
   let endpoint = "https://4557678.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1052&deploy=1&compid=4557678&h=c504088659c15c617b44";

    // Build string to be appended as parameter for shopify cart get URL
    var theURLParamsForShopify = Object.keys(url_params).map(function(k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(url_params[k])
    }).join('&');
  
  let adsURL = endpoint+"&"+theURLParamsForShopify
  
  let myIframe = document.getElementById("popupiframe");

   myIframe.src = adsURL;

    
  
});


// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  modal.style.display = "none"; 
   $('body').removeClass("overlay-active");  
 
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
    element.classList.remove("overlay-active");
  }
}

// Get the modal
var modal1 = document.getElementById("styleModal");

// Get the button that opens the modal
//var btn1 = document.getElementById("style-guide");
  

// Get the <span> element that closes the modal
var span1 = document.getElementsByClassName("close")[1];

// When the user clicks the button, open the modal 
  

// When the user clicks on <span> (x), close the modal
span1.onclick = function() {
  modal1.style.display = "none";  
}

// Get the modal
var modal2 = document.getElementById("termpopup");

// Get the button that opens the modal
//var btn2 = document.getElementById("termp");

  

// Get the <span> element that closes the modal
var span2 = document.getElementsByClassName("close")[2];

// When the user clicks the button, open the modal 
  
  
  
  
// btn2.onclick = function() {
//   modal2.style.display = "block";  
//   offsetHeight = document.getElementById('div_term_popup').offsetHeight;

// }

// When the user clicks on <span> (x), close the modal
span2.onclick = function() {
  modal2.style.display = "none";  
}



